import { useAuth0 } from '@auth0/auth0-react'
import { Box, Container, Flex, HStack, Image, Spinner, Text } from 'tcm-chakra-ui'
import { Link as RouterLink } from 'react-router-dom'
import DenimWhiteLogo from '../../assets/denim-white-logo.svg'
import { useAuthConfig } from '../../auth/authConfigContext'
import { LogoutButton } from '../auth/LogoutButton'

function EnabledAuthActions() {
  const { isAuthenticated, isLoading, user } = useAuth0()

  if (isLoading) {
    return (
      <Spinner
        size="sm"
        color="white"
        css={{
          color: 'var(--tcm-colors-text-white)',
          borderColor: 'rgba(255, 255, 255, 0.35)',
          borderTopColor: 'var(--tcm-colors-text-white)',
        }}
      />
    )
  }

  if (isAuthenticated) {
    return (
      <HStack gap={3}>
        <Text color="text.white" fontSize="sm">
          {user?.name || user?.email || 'Authenticated'}
        </Text>
        <LogoutButton />
      </HStack>
    )
  }
  return null
}

function DisabledAuthActions() {
  return (
    <Text color="whiteAlpha.800" fontSize="sm">
      Configure Auth0 env vars to enable sign in.
    </Text>
  )
}

export function NavBar() {
  const { isEnabled } = useAuthConfig()

  return (
    <Box as="header" bg="background.brandDark" boxShadow="sm">
      <Container maxW="7xl">
        <Flex
          minH="4rem"
          align="center"
          justify="space-between"
          gap={4}
          wrap="wrap"
        >
          <HStack gap={6}>
            <RouterLink to="/">
              <Image src={DenimWhiteLogo} alt="Denim Health" h="1.4rem" />
            </RouterLink>
          </HStack>
          {isEnabled ? <EnabledAuthActions /> : <DisabledAuthActions />}
        </Flex>
      </Container>
    </Box>
  )
}
